// Dispara o download de um CSV a partir de uma string (Blob + link temporário). Compartilhado pelo
// relatório CPC 25 (exports ao vivo) e pelo modal de fechamento (export do fechamento congelado).
const downloadCsv = (content: string, filename: string): void => {
    // BOM para o Excel abrir com acentuação correta.
    const blob = new Blob(['\ufeff' + content], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};

export default downloadCsv;
